import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import MultiImageUploader from '../components/MultiImageUploader';

const empty = { name:'', zone:'', address:'', image:'', gallery: [] };

const AdminHotels = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [search, setSearch] = useState('');

  const load = () => api.get('/hotels').then(r => setItems(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const gallery = Array.isArray(form.gallery) ? form.gallery : [];
      const payload = { ...form, gallery, image: gallery[0] || form.image || '' };
      if (editing) await api.put(`/hotels/${editing.id}`, payload);
      else await api.post('/hotels', payload);
      toast.success('Guardado');
      setOpen(false); load();
    } catch { toast.error('Error'); }
  };
  const remove = async (id) => {
    if (!window.confirm('¿Eliminar?')) return;
    try { await api.delete(`/hotels/${id}`); toast.success('Eliminado'); load(); } catch { toast.error('Error'); }
  };

  const filtered = items.filter(h => h.name.toLowerCase().includes(search.toLowerCase()) || h.zone.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-black text-white">Hoteles</h1>
          <p className="text-white/60">Gestiona hoteles disponibles</p>
        </div>
        <Button onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} className="btn-orange border-0 gap-2"><Plus className="w-4 h-4" /> Nuevo Hotel</Button>
      </div>
      <Input placeholder="Buscar..." value={search} onChange={(e)=>setSearch(e.target.value)} className="max-w-sm bg-black/40 border-white/10 text-white mb-5" />

      <div className="glass-card rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-black/60 text-white/70">
            <tr><th className="text-left p-4">Nombre</th><th className="text-left p-4">Zona</th><th className="text-left p-4">Dirección</th><th className="text-left p-4">Acciones</th></tr>
          </thead>
          <tbody>
            {filtered.map(h => (
              <tr key={h.id} className="border-t border-white/5">
                <td className="p-4 text-white">{h.name}</td>
                <td className="p-4 text-white/70">{h.zone}</td>
                <td className="p-4 text-white/50">{h.address || '-'}</td>
                <td className="p-4">
                  <div className="flex gap-2">
                    <button onClick={() => { 
                      const gallery = Array.isArray(h.gallery) && h.gallery.length ? h.gallery : (h.image ? [h.image] : []);
                      setEditing(h); setForm({ ...h, gallery }); setOpen(true); 
                    }} className="w-8 h-8 rounded bg-white/5 text-white/70 hover:bg-white/10 flex items-center justify-center"><Edit className="w-4 h-4" /></button>
                    <button onClick={() => remove(h.id)} className="w-8 h-8 rounded bg-red-600/20 text-red-400 hover:bg-red-600/40 flex items-center justify-center"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0f0f0f] border-white/10 text-white">
          <DialogHeader><DialogTitle>{editing ? 'Editar' : 'Nuevo'} Hotel</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div><Label>Nombre</Label><Input value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Zona</Label><Input value={form.zone} onChange={(e)=>setForm({...form,zone:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Dirección</Label><Input value={form.address} onChange={(e)=>setForm({...form,address:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Imágenes (la primera es la principal)</Label>
              <MultiImageUploader value={form.gallery} onChange={(urls) => setForm({...form, gallery: urls, image: urls[0] || ''})} folder="tts/hotels" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={()=>setOpen(false)} className="border-white/15 text-white">Cancelar</Button>
            <Button onClick={save} className="btn-orange border-0">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AdminHotels;
